import React, { Component } from 'react';
import TextField from '@mui/material/TextField';

import '../style/App.css';

//required Props receive and/or pass back to parent:
// - this.props.handleName(value) to pass up values to state (for sending to backend, passed up)
// - this.props.name (content of TextField, pass up and down)

class ContactName extends Component {
  constructor(props) {
    super(props)
    this.state = {
      name: ''
    }
    this.handleName = this.handleName.bind(this);
  }

  handleName(value) {
    this.props.handleName(value);
  }

  componentDidMount() {
    if (this.props.name) {
      console.log('name: ', this.props.name)
      this.setState({
        name: this.props.name
      })
    }
  }

  render() {
    return (
      <div className='contactFormFieldHolder'>
        <TextField
          onChange={(e) => this.handleName(e.target.value)}
          variant="outlined"
          id="name-form"
          label="name"
          value={this.props.name}
          sx={{
            width: '100%',
            '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgb(125, 120, 120)'
            },
            '& .MuiInputLabel-root': {
              color: 'rgb(125, 120, 120)'
            }
          }}
        />
      </div>
    )
  }

}

export default ContactName;
